module.exports = __webpack_public_path__ + "static/media/Logobeta.179053ba.svg";